import React, { useState } from 'react';
import FilterAssistenciaComponent from './filtroassistencia';
import Legenda from './legenda';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';

const PainelAssistencia = ({ legendData, selectedRede, currentColor, onFilterChange, onSelectMunicipio }) => {
    const [selectedUF, setSelectedUF] = useState(null);
    const [isExpanded, setIsExpanded] = useState(true);

    const togglePanel = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="painel-assistencia" style={{ backgroundColor: 'rgba(83, 108, 149, 0.5)', padding: '1em', borderRadius: '8px', position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <p style={{ margin: '0.4em', textAlign: 'center' }}>Painel de controle</p>
                <IconButton onClick={togglePanel} style={{ color: 'white' }}>
                    <MenuIcon />
                </IconButton>
            </div>
            {isExpanded && (
                <>
                    <FilterAssistenciaComponent dados={legendData} onChange={onFilterChange} onSelectMunicipio={onSelectMunicipio} />
                    <Legenda legendData={legendData} selectedRede={selectedRede} selectedUF={selectedUF} currentColor={currentColor} />
                </>
            )}
        </div>
    );
};

export default PainelAssistencia;
